import { render, staticRenderFns } from "./FullWidthFileImage.vue?vue&type=template&id=7101edfe&scoped=true&"
import script from "./FullWidthFileImage.vue?vue&type=script&lang=js&"
export * from "./FullWidthFileImage.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthFileImage.vue?vue&type=style&index=0&id=7101edfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7101edfe",
  null
  
)

export default component.exports